import { Tag, Plus } from 'lucide-react';
import Modal from '@/common/components/atom/modal';
import Button from '@/common/components/atom/button';
import TextField from '@/common/components/atom/textField';
import classNames from '@/common/utils/classNames';
import { useState } from 'react';
import { toast } from 'react-hot-toast';

interface DiscountProps {
  onSubmit: (code: string) => void;
  status?: 'default' | 'successful' | 'unSuccessful';
  errorMessage?: string;
  loading?: boolean;
}

export const Discount = (props: DiscountProps) => {
  const { errorMessage, status = 'default', onSubmit, loading } = props;
  const [code, setCode] = useState('');
  const [open, setOpen] = useState(false);

  const handleSubmit = () => {
    if (!code) return toast.error('لطفا کد تخفیف را وارد کنید.');
    onSubmit(code);
  };

  return (
    <section className="bg-white md:rounded-lg shadow-card">
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={open}
        className="flex w-full items-center gap-2.5 px-5 py-4 text-right"
      >
        <Tag size={20} strokeWidth={1.8} className="shrink-0 text-primary" />
        <span className="flex flex-1 flex-col gap-0.5">
          <span className="text-sm font-semibold">وارد کردن کد تخفیف</span>
          <span className="text-xs text-slate-500">{status === 'successful' ? 'کد تخفیف اعمال شد' : 'کد تخفیف خود را وارد کنید'}</span>
        </span>
        <Plus size={20} className="text-primary" />
      </button>
      <Modal
        isOpen={open}
        onClose={() => setOpen(false)}
        title="کد تخفیف"
        name="factor-discount"
        bodyClassName="!p-4 !pb-[calc(1rem+env(safe-area-inset-bottom))]"
      >
        <div className="flex w-full items-start gap-2">
          <TextField
            value={code}
            helperText={(status === 'unSuccessful' && errorMessage) || ''}
            onChange={e => setCode(e.target.value)}
            error={status === 'unSuccessful'}
            classNameWrapper="w-3/4"
            className={classNames({
              'border-teal-500 border-2 outline-teal-500': status === 'successful',
              'border-2': status === 'unSuccessful',
            })}
            readOnly={status === 'successful'}
            placeholder="کد تخفیف را وارد کنید ..."
          />
          <Button loading={loading} variant="secondary" className="!w-1/4" onClick={handleSubmit} disabled={status === 'successful'}>
            {status === 'successful' ? 'تایید شد' : 'بررسی'}
          </Button>
        </div>
      </Modal>
    </section>
  );
};
export default Discount;
